import { memo, useCallback } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { X } from 'lucide-react';

import StatusBadge from '../shared/StatusBadge';

/**
 * One address that already belongs to the workspace: flagged, never sent, removable from the list.
 *
 * @param {object} props
 * @param {{ email: string, name: string, status: string }} props.member
 * @param {(email: string) => void} props.onRemove
 */
function ExistingMemberRow({ member, onRemove }) {
  const { t } = useTranslation('people-access');
  const handleRemove = useCallback(() => onRemove(member.email), [onRemove, member.email]);

  return (
    <div className="flex items-center gap-3 text-sm">
      <span className="font-medium text-content">{member.name}</span>
      <span className="flex-1 truncate text-content-muted">{member.email}</span>
      <StatusBadge status={member.status} />
      <Button
        variant="ghost"
        size="sm"
        leftIcon={X}
        aria-label={t('invite.people.removeExisting', { email: member.email })}
        onClick={handleRemove}
      />
    </div>
  );
}

export default memo(ExistingMemberRow);
